type TcfApi = (command: 'displayConsentUi', version: 2, callback: () => void) => void;

type CookiePreferenceEvent = {
  preventDefault: () => void;
};

export const openCookiePreferences = (event?: CookiePreferenceEvent) => {
  event?.preventDefault();

  const { __tcfapi } = globalThis as typeof globalThis & { __tcfapi?: TcfApi };
  if (typeof __tcfapi === 'function') {
    __tcfapi('displayConsentUi', 2, () => undefined);
  }
};
